import { getMarketingHomeHref } from "@/config/marketingHome";

export default function AuthShell({
  className = "",
  title,
  subtitle,
  children,
  footer,
}) {
  const wrapClass = ["log-reg", className].filter(Boolean).join(" ");

  return (
    <section className={wrapClass}>
      <div className="overlay pb-120">
        <div className="container">
          <div className="top-head-area">
            <a href={getMarketingHomeHref()} className="back-home">
              <i className="icon-arrow-left" />
              Back to Paylio
            </a>
          </div>

          <div className="row justify-content-center">
            <div className="col-xxl-5 col-xl-6 col-lg-8">
              <div className="form-box">
                <h4 className="mb-3">{title}</h4>
                {subtitle ? <p className="mb-4">{subtitle}</p> : null}
                {children}
                {footer ? <div className="mt-4">{footer}</div> : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
